//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getFreeMediaTypeTranslations } from '@/helpers/freeMediaTypes.js';
import { getPartner } from '@/api/free-elements.js';

export default {
  name: 'FreeHero',
  props: {
    mediaTypeId: {
      type: String,
      required: true,
    },
    partnerId: {
      type: String,
      default: null,
    },
  },
  components: {
    FreeMediaTypesDropdown: () => import('@/components/free/FreeMediaTypesDropdown.vue'),
    ButtonFreeBookmarklet: () => import('@/components/free/ButtonFreeBookmarklet.vue'),
    FreeHeroPartner: () => import('@/components/free/FreeHeroPartner.vue'),
  },
  data() {
    return {
      isPartner: false,
      partnerData: {
        name: '',
        description: '',
        logo: {
          url: '',
        },
        cta: {
          heading: '',
          description: '',
          url: '',
          label: '',
        },
      },
    };
  },
  created() {
    if (this.partnerId) {
      this.getPartner(this.partnerId);
    }
  },
  computed: {
    heroTitle() {
      // eslint-disable-next-line newline-per-chained-call
      return _.upperFirst(this.$term('mediaType', this.mediaTypeId).wbr().seo().plural().free().html());
    },
    heroText() {
      return _.get(getFreeMediaTypeTranslations(this, this.mediaTypeId), 'seo_top_text_1');
    },
  },
  methods: {
    getPartner(id) {
      getPartner(id).then((response) => {
        this.partnerData = response.data.data;
        this.isPartner = true;
      });
    },
  },
};
